module.exports = __webpack_public_path__ + "static/media/entip.1189bf98.png";